import apiZelo from '../backAxiosVendaToken';

export const ListaAceites = async inscricao => {
    try {
        const response = await apiZelo.get(`/signatureOrderLink/${inscricao}`);

        return response.data;
    } catch (error) {
        return error.message;
    }
};
